export const DVEBabylon = {
    system: {},
    $INIT(system) {
        this.system = system;
    }
};
